<template>
  <div id="layout-default">
    <header class="sticky-top">
      <slot name="header"></slot>
    </header>
    <main>
      <transition name="fade" mode="out-in" appear>
        <slot name="pages"></slot>
      </transition>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style lang="scss">
#layout-default {
  main {
    min-height: calc(100vh - 104px - 280px);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
<script>
export default {
  name: 'Layout',
};
</script>
